

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-carica_pacchetto_fase3",
    templateUrl: "./dialog-carica_pacchetto_firmato_fase3.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaPacchettoFirmatoFase3 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoDoc:String="";
    
    protected file: File;
    protected selectedFiles: File[] = [];
    protected isUploadingDoc:boolean = false;
    
    protected label:string="Cerca i DUE file FIRMATI che compongono il PACCHETTO" ;
    protected icona:string="";
    protected stile:string="btn-choose-file-preventivo";
    protected fileClass:string="btn-choose-file-preventivo";
    protected acceptedFileTypes:string=".pdf,.zip,.p7m";
    protected isBando2: boolean = false;
    protected multiple: boolean = true;



    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
      this.isBando2 = this.pratica.bando === "BANDO 2";
      this.multiple = !this.isBando2; // Solo BANDO 1 permette caricamento multiplo
      
      // Imposta il label appropriato in base al bando
      if (this.isBando2) {
        this.label = "Cerca il file FIRMATO del PACCHETTO";
      } else {
        this.label = "Cerca i DUE file FIRMATI che compongono il PACCHETTO";
      }
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){
      this.logger.info('Evento onFileUpload ricevuto:', $event);
    }

    onFileSelect($event: { files: File[]; }) {
      this.logger.info('Evento onFileSelect ricevuto:', $event);
      this.logger.info('Files nell\'evento:', $event.files);
      
      if ($event && $event.files && $event.files.length > 0) {
        // Per BANDO 2, limita a un solo file
        if (this.isBando2 && $event.files.length > 1) {
          this.messageService.add({
            severity: "warn",
            summary: "Attenzione",
            life: 5000,
            detail: "Per il BANDO 2 è possibile caricare un solo file!",
          });
          // Prendi solo il primo file
          this.selectedFiles = [$event.files[0]];
        } else {
          this.selectedFiles = [...$event.files]; // Usa spread operator per creare una copia
        }
        
        this.logger.info('File selezionati dopo assegnazione:', this.selectedFiles);
        this.logger.info('Lunghezza selectedFiles:', this.selectedFiles.length);
        
        // Aggiorna il label in base al numero di file e al tipo di bando
        if (this.isBando2) {
          this.label = "1 file selezionato";
        } else {
          this.label = `${this.selectedFiles.length} file selezionato${this.selectedFiles.length > 1 ? 'i' : ''}`;
        }
        
        this.icona = "pi pi-check";
        this.fileClass = "btn-preventivo-upload-success";
        this.file = this.selectedFiles[0]; // Mantiene compatibilità con il file singolo
        
        // Forza il change detection
        setTimeout(() => {
          this.logger.info('Stato finale - selectedFiles.length:', this.selectedFiles.length);
        }, 100);
      } else {
        this.logger.warn('Nessun file valido nell\'evento onFileSelect');
        this.resetFiles();
      }
    }

    onFileRemove($event: { files: File[]; }) {
      this.logger.info('Evento onFileRemove ricevuto:', $event);
      this.resetFiles();
    }

    private resetFiles() {
      this.selectedFiles = [];
      this.file = null;
      if (this.isBando2) {
        this.label = "Cerca il file FIRMATO del PACCHETTO";
      } else {
        this.label = "Cerca i DUE file FIRMATI che compongono il PACCHETTO";
      }
      this.icona = "";
      this.fileClass = "btn-choose-file-preventivo";
    }

    // Metodo per verificare se ci sono file selezionati
    get hasSelectedFiles(): boolean {
      return this.selectedFiles && this.selectedFiles.length > 0;
    }

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        if (this.selectedFiles.length > 1 && !this.isBando2) {
          // Gestione di più file (solo per BANDO 1)
          const promises: Promise<void>[] = [];
          
          this.selectedFiles.forEach(file => {
            const promise = new Promise<void>((resolve, reject) => {
             
              const fileName = this.pratica.cui + "/OUT/FASE3/SIGNED/" + file.name;
              
              this.googleStorageService
                .uploadFileScuolaToGoogleStorage(file, fileName)
                .then((uploadRes) => {
                  this.logger.info(`File ${file.name} caricato con successo`);
                  resolve();
                })
                .catch((errore) => {
                  this.logger.error(`Errore nel caricamento del file ${file.name}:`, errore);
                  reject(errore);
                });
            });
            
            promises.push(promise);
          });
          
          Promise.all(promises)
            .then(() => {
              this.messageService.add({
                severity: "success",
                summary: "Successo",
                life: 5000,
                detail: "Tutti i file sono stati caricati con successo!",
              });
              this.dialogRef.close({ success: true });
            })
            .catch((error) => {
              this.logger.error("Errore durante l'esecuzione delle promesse:", error);
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                life: 10000,
                detail: "Errore in fase di caricamento di uno o più file!",
              });
              this.dialogRef.close({ success: false });
            });
        } else if (this.selectedFiles.length === 1) {
          // Gestione di un singolo file (per entrambi i bandi)
          const file = this.selectedFiles[0];
          const fileName = this.pratica.cui + "/OUT/FASE3/SIGNED/" + file.name;
          
          this.googleStorageService
            .uploadFileScuolaToGoogleStorage(file, fileName)
            .then((uploadRes) => {
              this.messageService.add({
                severity: "success",
                summary: "Successo",
                life: 5000,
                detail: "File caricato con successo!",
              });
              this.dialogRef.close({ success: true });
            })
            .catch((errore) => {
              this.logger.error("Errore nel caricamento del file:", errore);
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                life: 10000,
                detail: "Errore in fase di caricamento File!",
              });
              this.dialogRef.close({ success: false });
            });
        } else {
          // Nessun file selezionato
          this.messageService.add({
            severity: "warn",
            summary: "Attenzione",
            life: 5000,
            detail: "Nessun file selezionato!",
          });
          this.dialogRef.close({ success: false });
        }
      } 
    }
  
  }